import React, { useContext, useEffect, useState } from 'react'
import { addZero } from '../../../utils/timeFormat'
import {
  Box,
  Typography,
  IconButton,
  Drawer,
  Card,
  CardContent,
} from '@mui/material'
import { makeStyles } from "@mui/styles";
import { AuctionContext } from '../../../context/auctionContext'
import NotificationsIcon from '@mui/icons-material/Notifications'
import Badge from '@mui/material/Badge'

const useStyles = makeStyles((theme) => ({
  iconButton: {},
  announcement: {
    maxWidth: '100%',
    margin: '.5rem',
    backgroundColor: '#ECECECCC',
  },
  announcementContent: {
    margin: '.5rem',
    backgroundColor: '#ECECECCC',
  },
  announcementsContainer: {
    padding: '1rem',
  },
  drawerContent: {
    width: 300,
  },
  content: {},
  title: {
    fontSize: 18,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
      paddingButtom: theme.spacing(2),
    },
    flex: 1,
    color: theme.palette.primary.main,
    padding: 15,
    textAlign: 'left',
    marginLeft: theme.spacing(4),
    fontFamily: 'ITC Officina Sans Std, sans-serif',
    fontWeight: 700,
  },
  announcementText: {
    flex: 1,
    color: theme.palette.primary.main,
    fontSize: 18,
    marginTop: theme.spacing(1),
  },
}))

const AnnouncementNavBar = React.forwardRef((props, ref) => {
  const { auction, readed, setReaded } = useContext(AuctionContext)
  const classes = useStyles()
  const [openAnnouncements, setOpenAnnouncements] = useState(false)
  const toggleAnnouncements = () => {
    setOpenAnnouncements(!openAnnouncements)
    setReaded(auction?.announcements?.length | 0)
  }
  useEffect(() => {
  }, [auction])
  return (
    <Box className={classes.content} ref={ref}>
      {auction?.announcements ? (
        <IconButton
          color="secondary"
          aria-label="announcements"
          className={classes.iconButton}
          size="large">
          <Badge
            color="error"
            onClick={toggleAnnouncements}
            badgeContent={(auction?.announcements?.length - readed) | 0}
          >
            <NotificationsIcon sx={{ color: "#fff" }} />
          </Badge>
        </IconButton>
      ) : null}
      <Drawer
        anchor="right"
        open={openAnnouncements}
        onClose={toggleAnnouncements}
      >
        <Box className={classes.drawerContent}>
          <Typography className={classes.title}>ANUNCIOS</Typography>
          <Box className={classes.announcementsContainer}>
            {auction?.announcements?.map((announcement, index) => {
              const announcemenDate = new Date(announcement.date)
              let h = addZero(announcemenDate.getHours())
              let m = addZero(announcemenDate.getMinutes())
              let announcemenTime = h + ':' + m /*  */
              return (
                <Card className={classes.announcement}>
                  <CardContent className={classes.announcementContent}>
                    <Typography
                      key={index}
                      variant="body1"
                      className={classes.announcementText}
                    >
                      {`${announcemenTime} - ${announcement.message}`}
                    </Typography>
                  </CardContent>
                </Card>
              )
            })}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
})

export default AnnouncementNavBar
